import { useEffect, useRef, useState } from "react";

const TICK_MS = 30000;

export default function useVenueClock(serverTime) {
  const anchor = useRef(null);
  const [now, setNow] = useState(serverTime ?? null);

  /* Re-anchored whenever the server speaks again. */
  useEffect(() => {
    anchor.current = serverTime
      ? { at: new Date(serverTime).getTime(), since: Date.now() }
      : null;

    setNow(serverTime ?? null);
  }, [serverTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!anchor.current) return;

      const { at, since } = anchor.current;
      setNow(new Date(at + (Date.now() - since)).toISOString());
    }, TICK_MS);

    return () => clearInterval(timer);
  }, []);

  return now;
}
